import styles from './styles.module.scss';

type Props = {
  /** 時刻の現在値（"HH:MM" 形式） */
  value: string;
  /** 非活性状態 */
  disabled?: boolean;
  /** プレースホルダー */
  placeholder?: string;
  /** 時刻変更ハンドラ */
  onChange?: (time: string) => void;
};

/**
 * 時刻入力コンポーネント。
 * HTML の `<input type="time">` をベースに DatePicker と統一されたスタイルを提供する。
 */
export const TimeInput: React.FC<Props> = ({ value, disabled, placeholder, onChange }) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(e.target.value);
  };

  return (
    <input
      type='time'
      value={value}
      disabled={disabled}
      placeholder={placeholder}
      onChange={handleChange}
      className={styles.timeInput}
    />
  );
};
